// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"607ddbb5","427":"ab920118","760":"57a72383"}[chunkId] + ".chunk.css";
};